var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{model:{value:(_vm.dialogConfigFormBuilder),callback:function ($$v) {_vm.dialogConfigFormBuilder=$$v},expression:"dialogConfigFormBuilder"}},[_c('div',{attrs:{"id":"surveyCreator"}})])}
var staticRenderFns = []

export { render, staticRenderFns }